import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrgBranches } from '../../actions/org';
import Select from '../../common/Form/Select';
import { useFormContext } from 'react-hook-form';
import { actualValueForDropdown, debounce } from '../../utils/common';
import Input from '../../common/Form/Input';
import { CLEAR_ORG_BRANCHES_DROPDOWN_LIST_DATA } from '../../types/org';
import { TicketAgentRole } from '../../pages/Ticket/TicketController';


const Branch = ({ name, label, onChange = () => { }, org_id, className, required = false, prefill = [], readOnly = false, add_new = false, showInputIfEmpty, cleanup = true }) => {
    const methods = useFormContext();
    const dispatch = useDispatch();
    const orgBranchesDropdown = useSelector((state) => state.org.orgBranchesDropdown);
    const isOrgBranchesLoading = useSelector((state) => state.loading.isOrgBranchesLoading);
    const { watch } = useFormContext();
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    let showAddNewBranchOption = add_new;
    if (newLoggedUserData.org.id === 'org_2wjcBEg5Y2rrFdp1hjpNMTqqmB7') {
        showAddNewBranchOption = newLoggedUserData.user.roles.some((role) => ['OWNER'].includes(role.label.toUpperCase()));
    }

    const memoizedOrgBranches = useMemo(() => {
        let data = [];
        if (orgBranchesDropdown?.[org_id]) {
            data = [...orgBranchesDropdown[org_id]];
        }
        if (showAddNewBranchOption) {
            data.unshift({ label: 'Add New Branch', value: 'add-new-branch' })
        }
        return data;
    }, [orgBranchesDropdown, org_id, showAddNewBranchOption]);

    const getBranchs = ({ limit = 100, page = 1, query = '', org_id }) => {
        dispatch(getOrgBranches({ limit, page, query, orgId: org_id, dropdown: true }));
    };

    const debouncedEnduserSearchSearch = useCallback(debounce(getBranchs), []);

    useEffect(() => {
        if (org_id) {
            getBranchs({ limit: 100, page: 1, query: '', org_id });
            methods.setValue(name, null);
        }
    }, [org_id]);

    useEffect(() => {
        if (cleanup) {
            return () => {
                dispatch({ type: CLEAR_ORG_BRANCHES_DROPDOWN_LIST_DATA });
            }
        }
    }, [dispatch, cleanup]);

    useEffect(() => {
        if (prefill && prefill.length > 0 && memoizedOrgBranches && memoizedOrgBranches.length > 0) {
            const find = memoizedOrgBranches.find((option) => prefill.includes(option.id));
            if (find) {
                methods.setValue(name, find);
            }
        }
    }, [prefill, memoizedOrgBranches]);

    const isAddNew = actualValueForDropdown(watch(name)) === 'add-new-branch';

    return <>
        {memoizedOrgBranches.length > 0 ? <Select
            name={name}
            label={label}
            options={memoizedOrgBranches}
            isLoading={isOrgBranchesLoading}
            required={required}
            className={className}
            shouldUnregister
            onInputChange={(event) => {
                if (event.length > 0) {
                    debouncedEnduserSearchSearch({ query: event, org_id })
                }
            }}
            onChange={(event) => {
                const value = event?.value;
                onChange(value)
            }}
            readOnly={readOnly}
        /> : null}
        {isAddNew && <Input className={className} required={required} name={`${name}:new`} label={`${label}`} />}
        {showInputIfEmpty && memoizedOrgBranches.length === 0 ? <Input shouldUnregister className={className} required={required} name={`${name}`} label={`${label}`} /> : null}
    </>
}

export default Branch;
